"use client";

import React, { ReactNode, Suspense, useEffect } from "react";
import ReduxProvider from "../src/@redux/ReduxProvider";
import "../src/styles/reset.css";
import SVGSpriteClient from "./_lib/SVGSpriteClient";
import { Elements as StripeElements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import GaListener from "./_components/GaListener";
import ErrorBoundary from "./_components/ErrorBoundary";
import StyledComponentsRegistry from "./_lib/registry";
import { settings } from "shared";

export default function ClientProviders({ children }: { children: ReactNode }) {
  // Prevent browser from opening files dragged outside of app drop zones
  useEffect(() => {
    const prevent = (e: DragEvent) => e.preventDefault();
    document.addEventListener("dragover", prevent);
    document.addEventListener("drop", prevent);
    return () => {
      document.removeEventListener("dragover", prevent);
      document.removeEventListener("drop", prevent);
    };
  }, []);

  return (
    <StyledComponentsRegistry>
      <StripeElements stripe={loadStripe(settings.stripePublishableKey)}>
        <ReduxProvider>
          <SVGSpriteClient />
          <GaListener>
            <ErrorBoundary>
              <Suspense>{children}</Suspense>
            </ErrorBoundary>
          </GaListener>
        </ReduxProvider>
      </StripeElements>
    </StyledComponentsRegistry>
  );
}
